var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpacitySmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66667 11.0767C3.36844 11.0767 2.26622 10.634 1.36 9.74867C0.453333 8.86289 0 7.77222 0 6.47667C0 5.85711 0.124 5.27178 0.372 4.72067C0.619556 4.16956 0.949333 3.67533 1.36133 3.238L4.66667 0L7.972 3.238C8.384 3.67578 8.71378 4.17 8.96133 4.72067C9.20933 5.27178 9.33333 5.85711 9.33333 6.47667C9.33333 7.77222 8.88 8.86289 7.97333 9.74867C7.06755 10.634 5.96533 11.0767 4.66667 11.0767ZM0.713333 7.07667H8.61333C8.74667 6.27667 8.66933 5.58911 8.38133 5.014C8.09378 4.43889 7.8 4.00689 7.5 3.718L4.66667 0.918L1.83333 3.718C1.53333 4.00689 1.24111 4.43889 0.956667 5.014C0.672222 5.58911 0.590889 6.27667 0.712666 7.07667",
    fill: "#9F9F9F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpacitySmall);
export default __webpack_public_path__ + "static/media/opacity-small.05bda7352081bb9523650cf7f18fead4.svg";
export { ForwardRef as ReactComponent };